import styled from 'styled-components';

const Root = styled.div `
  &.tend-ui-drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    border-bottom: none;
  }
`;

export { Root };
//# sourceMappingURL=styled.js.map
